import { ref, watch } from 'vue'
import { calculateBoundingBox } from 'Common/utils/calculateBoundingBox'
import { applyMatrix } from 'Common/utils/markerArea/helperFunctions'
import { AnnotationPopoverPositions } from 'Modules/types/pages/imageReview/enums'
import type { Ref } from 'vue'
import type { TransformMatrixType } from 'Common/utils/markerArea/types'
import type { ImageAnnotationType } from 'Modules/types/pages/imageReview/imageAnnotationType'

interface PopoverPosition {
  locationX?: number
  locationY?: number
  position?: AnnotationPopoverPositions
}

export function useAnnotationPopoverPosition(
  annotation: ImageAnnotationType,
  transformMatrix: TransformMatrixType
): PopoverPosition {
  let positionData
  if (annotation) {
    const scaledBounds = annotation.defectBounds.map((bound) => {
      const scaledBound = applyMatrix(bound[0], bound[1], transformMatrix)
      return [scaledBound.x, scaledBound.y]
    })

    const box = calculateBoundingBox(scaledBounds)

    positionData = {
      locationX: (box.left + box.right) / 2,
      locationY: box.top,
      position: AnnotationPopoverPositions.Top,
    }
  } else {
    positionData = null
  }

  return positionData
}
